// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

const VOUCHERS_START_RECENT_LOADER = 'VOUCHERS_START_RECENT_LOADER';
const VOUCHERS_STOP_RECENT_LOADER = 'VOUCHERS_STOP_RECENT_LOADER';

const VOUCHERS_START_SEARCH_LOADER = 'VOUCHERS_START_SEARCH_LOADER';
const VOUCHERS_STOP_SEARCH_LOADER = 'VOUCHERS_STOP_SEARCH_LOADER';

const CHANGE_SEARCH_FIELD = 'CHANGE_SEARCH_FIELD';
const VOUCHERS_CLEAR_SEARCH_RESULT = 'VOUCHERS_CLEAR_SEARCH_RESULT';

const GET_BOOKSHOP_TOTAL = 'GET_BOOKSHOP_TOTAL';
const GET_RECENT_VOUCHERS = 'GET_RECENT_VOUCHERS';

const GET_BOOKSHOP_TOTAL_SUCCESS = 'GET_BOOKSHOP_TOTAL_SUCCESS';
const GET_RECENT_VOUCHERS_SUCCESS = 'GET_RECENT_VOUCHERS_SUCCESS';

const SEARCH_VOUCHERS = 'SEARCH_VOUCHERS';
const SEARCH_VOUCHERS_SUCCESS = 'SEARCH_VOUCHERS_SUCCESS';

export {
  VOUCHERS_START_RECENT_LOADER,
  VOUCHERS_STOP_RECENT_LOADER,

  VOUCHERS_START_SEARCH_LOADER,
  VOUCHERS_STOP_SEARCH_LOADER,

  CHANGE_SEARCH_FIELD,
  VOUCHERS_CLEAR_SEARCH_RESULT,

  GET_BOOKSHOP_TOTAL_SUCCESS,
  GET_RECENT_VOUCHERS_SUCCESS,

  SEARCH_VOUCHERS,
  SEARCH_VOUCHERS_SUCCESS,

  GET_BOOKSHOP_TOTAL,
  GET_RECENT_VOUCHERS,
};
